module.exports = __webpack_public_path__ + "static/media/signature.1682144a.png";